
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","viewBox":"0 0 136 136"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M68 0c37.555 0 68 30.445 68 68s-30.445 68-68 68S0 105.555 0 68 30.445 0 68 0zm0 5C33.206 5 5 33.206 5 68s28.206 63 63 63 63-28.206 63-63S102.794 5 68 5z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M68 22.447a45.44 45.44 0 0116.788 3.194 45.438 45.438 0 018.683 4.587l.169.114a732.243 732.243 0 00-13.45 6.682c-1.215-.815-2.11-1.299-4.07-2.075a38.838 38.838 0 00-14.354-2.73c-21.084 0-38.616 13.645-39.299 34.503l-.015.618v-.093c.403-24.811 20.641-44.8 45.548-44.8z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M100.35 33.67S84.87 72.168 79.16 78.088c-5.735 5.915-15.009 5.915-20.718 0-5.741-5.92-5.741-15.486-.01-21.406 5.72-5.887 41.917-23.012 41.917-23.012zM68 60.078a7.922 7.922 0 100 15.844 7.922 7.922 0 000-15.844z"}})])])
          )
        }
      }
    